window.$ = jQuery;

// Import commons libraries
// import 'bootstrap-select/dist/js/bootstrap-select.js';

import Router from './util/Router';
import common from './routes/common';

// Import CSS
import '../scss/main.scss';

console.log('app.js loaded');

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
});

// Load Events
$(document).ready(($) => routes.loadEvents());
